import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);
//const urlmaster = `https://casinoarenia-ws.idooproject.com`;
const recurso = "https://casino-arenia-store-qa.s3.amazonaws.com";

const urlmaster = `https://casino-ws.qa.idooproject.com`;
//const urlmaster = `https://casino-ws-qa.qa.idooproject.com`;
//const urlmaster = `http://localhost:8000`
axios.defaults.headers.post["Content-Type"] = "application/json";

/*function floatToString(num) {
  return num.toFixed(Math.max(1, num.toString().substr(num.toString().indexOf(".")+1).length));
}*/
function pricesyle(price) {
  var p = true;
  var x = price.toString();
  for (var j = 0; j < x.length; j++) if (x[j] == "," || x[j] == ".") p = false;
  if (p == true) x = x + ".00";
  return x;
}
export default new Vuex.Store({
  state: {
    Sidebar_drawer: null,
    CantTry:2,
    Customizer_drawer: false,
    SidebarColor: "#1d2228", //Change Sidebar Color || 'white', | "#2b2b2b" | "rgb(44, 59, 164)" | "rgb(96, 44, 164)" | "rgb(151, 210, 219)" | "rgb(77, 86, 100)"
    SidebarBg: "",
    navbarColor: "white",
    setHorizontalLayout: false, // Horizontal layout
    token: null,
    VerticalSidebarItems:[],
    headertoken: null,
    islogin: false,
    userlist: [],
    casinolist: [],
    casinobyid: [],
    rewardlist:[],
    rafflelist:[],
    levelselect:null,
    slotlist: [],
    dishlist: [],
    citylist: [],
    frequencylist: [],
    menulist: [],
    menubyid: [],
    restaurantlist: [],
    restaurantbyid: [],
    promotionlist: [],
    promotionbyid: [],
    configlist: [],
    casinostadistic: {},
    urlwork: recurso,
    userdata: null,
    userbyid: [],
    objlogin: null,
    datamenu: null,
    datacasino: null,
    datarestaurant: null,
    datacasinodetail: null,
    polllist: [],
    asklist: [],
    reservationlist: [],
    promotiongenerallist:[],
    promotiongallery:[],
    levellist:[],
    downloadpromotionlist:[],
    promotionexecutionlist:[],
    promotionselect:null,
    
    versionApp: [],
    imageApp: [],

    allActiveReservation: {},
  },
  mutations: {
    SET_SIDEBAR_DRAWER(state, payload) {
      state.Sidebar_drawer = payload;
    },
    SET_CUSTOMIZER_DRAWER(state, payload) {
      state.Customizer_drawer = payload;
    },
    SET_SIDEBAR_COLOR(state, payload) {
      state.SidebarColor = payload;
    },
    SET_NAVBAR_COLOR(state, payload) {
      state.navbarColor = payload;
    },
    SET_LAYOUT(state, payload) {
      state.setHorizontalLayout = payload;
    },
    SET_TOKEN(state, payload) {
      state.setHorizontalLayout = payload;
    },
    login: async function (state, objuser) {
      state.objlogin = objuser;
      await axios({
        method: "post",
        url: `${urlmaster}/login/`,
        data: JSON.stringify(objuser),
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        responseType: "json",
        responseEncoding: "utf8",
      })
        .then(function (response) {
          state.token = response.data.token;
          state.islogin = true;
          state.headertoken = "Token " + state.token;
          console.log(state.token);
          console.log(state.islogin);
          axios.defaults.headers.post["Authorization"] = state.headertoken;
        })
        .catch(function (error) {
          console.log(error);
        });

      //state.islogin = true;
      console.log("Corrido Login");

      return new Promise((resolve, reject) => {
        console.log("Todo listo");
        resolve();
        if (state.token == undefined) reject();
      });
    },
    getPromotionGeneralList: async function (state, id) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: `query
     {
      promotionprincipal(id:${id})
       {
     id,name,createdAt, photo {id,photo},active,description,
     gallery{
       id,photo,principal,order
     }
   }
       
     }`,
        })
        .then(function (response) {
          state.promotiongenerallist = null;

          state.promotiongenerallist = response.data.data.promotionprincipal;
          return state.promotiongenerallist
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getPromotionGeneralofCasinoList: async function (state, id) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: `query
     {
      promotionprincipalofcasino(id:${id})
       {
     id,name,createdAt, photo {id,photo},active,description,
     gallery{
       id,photo,principal,order
     }
   }
       
     }`,
        })
        .then(function (response) {
          state.promotiongenerallist = null;

          state.promotiongenerallist = response.data.data.promotionprincipalofcasino;
          return state.promotiongenerallist
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getRafflebyLevel: async function (state, id) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: `query
     {
  rafflebylevel(id:${id})
    {
      id,name,description,order,active,photo
      frequency{id,name,description,active},
      level{id,name,description,order,active}
    }
       
     }`,
        })
        .then(function (response) {
          state.rafflelist = null;

          state.rafflelist = response.data.data.rafflebylevel;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getRewardbyLevel: async function (state, id) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: `query
     {
  rewardbylevel(id:${id})
    {
      id,name,description,order,active,photo
      frequency{id,name,description,active},
      level{id,name,description,order,active}
    }
       
     }`,
        })
        .then(function (response) {
          state.rewardlist = null;

          state.rewardlist = response.data.data.rewardbylevel;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getPromotionExecutionbyPromotion: async function (state, id) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: `query
     {
  promotionexecutionbypromotion(id:${id})
    {
      id,code,utilized,activedate,
    casino{id,name},
    usercasino{id,device},
    promotion{id,photo}
    }
       
     }`,
        })
        .then(function (response) {
          state.promotionexecutionlist = null;

          state.promotionexecutionlist = response.data.data.promotionexecutionbypromotion;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getPromotionExecutionbyCasino: async function (state, id) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: `query
     {
  promotionexecutionall(id:${id})
    {
      id,code,activedate,utilized,
    promotion
      {id,photo,
       casino
       {id,name}
      },
    usercasino
    {id,device}
    }
       
     }`,
        })
        .then(function (response) {
          state.promotionexecutionlist = null;

          state.promotionexecutionlist = response.data.data.promotionexecutionall;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getDownloadPromotionbyCasino: async function (state, id) {
      state.downloadpromotionlist = [];
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: `query
     {
      downloadpromotionbycasino(id:${id})
     {
   id, createdAt, active
  photo

  }
       
     }`,
        })
        .then(function (response) {
          state.downloadpromotionlist = [];

/**
 query
     {
      downloadpromotionbycasino(id:${id})
     {
   id, createdAt, active
  photo,
    promotionexecution
    {
      id,code,
      usercasino {
        id,device
        
      }
    }

  }
       
     }
 */


          state.downloadpromotionlist = response.data.data.downloadpromotionbycasino;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getLevelsbyCasino: async function (state, id) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: `query
     {
      levelbycasino(id:${id})
     {
    id,name,description,photo,createdAt, active,
    casino{id,name},
    raffles
    {
      id,name ,active, description, createdAt, photo 
    },
    promotions
    {
      id,name,photo,description,active,date, createdAt
    },
    raffles
    {
      id,name,description,active,photo,createdAt
    }
  }
       
     }`,
        })
        .then(function (response) {
          state.levellist = null;

          state.levellist = response.data.data.levelbycasino;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getReservation: async function (state, id) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: `query
     {
      reservationbyrestaurant(id:${id})
      {
        id,client{name,number},date,time,person,dateandtime,
        status
        {
          id,description,color
        },
        restaurant
        {
          cantTableFree,totalTable
        }
      }
       
     }`,
        })
        .then(function (response) {
          state.reservationlist = null;

          state.reservationlist = response.data.data.reservationbyrestaurant;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getAllActiveReservation: async function (state, ids) {
      const reservations = {};

      const promises = ids.map(async (id) => {
        try {
          const response = await axios.post(`${urlmaster}/graphql/`, {
            query: `query
       {
        reservationbyrestaurant(id:${id})
        {
          id,client{name,number},date,time,person,dateandtime,
          status
          {
            id,description,color
          },
          restaurant
          {
            id,cantTableFree,totalTable
          }
        }
         
       }`,
          });

          reservations[id] = response.data.data.reservationbyrestaurant;
        } catch (error) {
          console.log(error);
        }
      });

      await Promise.all(promises);

      state.allActiveReservation = [reservations];
    },

    getPolls: async function (state) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: `query
     {
      allPolls
      {
        id,name,description,active,delete,
        questionnaire{
          id,name
        }
      }
       
     }`,
        })
        .then(function (response) {
          state.polllist = null;

          state.polllist = response.data.data.allPolls;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getAskofPoll: function (state, id) {
      for (let i = 0; i < state.polllist.length; i++)
        if (state.polllist[i].id === id)
          state.asklist = state.polllist[i].questionnaire;
    },
    getGalleryofPromotionGeneral: function (state, id) {
      for (let i = 0; i < state.promotiongenerallist.length; i++)
        if (state.promotiongenerallist[i].id === id)
                state.promotiongallery = state.promotiongenerallist[i].gallery;
               
    },
    getDataUser: async function (state) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: `query
     {
      userbyusername(username:"${state.objlogin.username}")
       {
        id, firstName,lastName,username,email,principal,rol,casino{id,name,contact,order}
       }
       
     }`,
        })
        .then(function (response) {
          state.userdata = null;

          state.userdata = response.data.data.userbyusername;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getConfig: async function (state) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: `query
     {
      configlist
      {
        id,name,description,photo,active
      }
       
     }`,
        })
        .then(function (response) {
          state.configlist = null;

          state.configlist = response.data.data.configlist;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getUserbyId: function (state, id) {
      axios
        .post(`${urlmaster}/graphql/`, {
          query: `query
     {
      userbyid(id:${id})
       {
        id, firstName,email,principal,
         casino{id,name,segob,contact,city{id,name,description},
           active,phone,order,
           restaurant{
         description,active,id
       }
         }
       }
       
     }`,
        })
        .then(function (response) {
          state.userbyid = [];

          state.userbyid = response.data.data.userbyid;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getAllUser: async function (state) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: `{
      allAccount{id, username,firstName,lastName,email,isSuperuser,isActive,isStaff,rol}
      }`,
        })
        .then(function (response) {
          state.userlist = [];
          if (state.userdata[0].principal == true)
            for (let i = 0; i < response.data.data.allAccount.length; i++) {
              let aux = {
                id: response.data.data.allAccount[i].id,
                avatar: "1.png",
                firstname: response.data.data.allAccount[i].firstName,
                lastname: response.data.data.allAccount[i].lastName,
                username: response.data.data.allAccount[i].username,
                useremail: response.data.data.allAccount[i].email,
                isSuperuser: response.data.data.allAccount[i].isSuperuser,
                isActive: response.data.data.allAccount[i].isActive,
                isStaff: response.data.data.allAccount[i].isStaff,
                selectrole: response.data.data.allAccount[i].rol,
                rol:response.data.data.allAccount[i].rol
              };
              if (response.data.data.allAccount[i].isSuperuser == true)
                aux.selectrole = "Administrador";
              state.userlist.push(aux);
            }
          else
            for (let i = 0; i < response.data.data.allAccount.length; i++)
              if (
                state.objlogin.username ==
                response.data.data.allAccount[i].username
              ) {
                let aux = {
                  id: response.data.data.allAccount[i].id,
                  avatar: "1.png",
                  firstname: response.data.data.allAccount[i].firstName,
                  lastname: response.data.data.allAccount[i].lastName,
                  username: response.data.data.allAccount[i].username,
                  useremail: response.data.data.allAccount[i].email,
                  isSuperuser: response.data.data.allAccount[i].isSuperuser,
                  isActive: response.data.data.allAccount[i].isActive,
                  isStaff: response.data.data.allAccount[i].isStaff,
                  selectrole: response.data.data.allAccount[i].rol,
                  rol:response.data.data.allAccount[i].rol
                };
                if (response.data.data.allAccount[i].isSuperuser == true)
                  aux.selectrole = "Administrador";
                state.userlist.push(aux);
              }
          //  state.userlist = response.data.data.users;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getCasinoStadistic: function (state) {
      axios
        .post(`${urlmaster}/graphql/`, {
          query: `
     query
     {
  
      casinostadisticall(userId:0)
      {
        cantCasino,cantRestaurant,cantMenus,cantDish,
        cantTransmission,cantGames,cantMusical,cantSlots
      }

     }`,
        })
        .then(function (response) {
          state.casinostadistic = {};
          state.casinostadistic = response.data.data.casinostadisticall;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getAllPromotion: function (state) {
      axios
        .post(`${urlmaster}/graphql/`, {
          query: `
     query
     {
  
      promotionsList
      {
        results
        {
          id,name,description,active,date,photo,notif,
          restaurants{
            description,name,id,active,photo
          }
        }
      }

     }`,
        })
        .then(function (response) {
          state.promotionlist = [];
          state.promotionlist = response.data.data.promotionsList.results;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getRestaurantbyID: async function (state, id) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: `
     query
     {
      restaurantbyid(id:${id})
        {
          name,description,active, id,isOpen,isPrincipal,photo,shedule,sheduleBegin,sheduleEnd,
          menusof
          {
          id,active,name,order,photo,typeMenu  
          },
          promotions
          {
            id,date,description,name,photo
          },
          reservations{
            id,date,time,client{id,name,number},table,person,date,time,dateandtime,
            status
            {
              id,description,color
            },tstatus, tcolor, end, clientname, clientmovil, datetimeend
          },
          buffets
          {
            id,name,breakfastPrice,lunchPrice,dinePrice,description,photo,date
          },
          menus{
            id,name,typeMenu,active,photo,order
          }
        }
      }`,
        })
        .then(function (response) {
          state.restaurantbyid = [];
          state.restaurantbyid = response.data.data.restaurantbyid[0];
          console.log("Carga de datos realizada");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getPromotionbyID: function (state, id) {
      axios
        .post(`${urlmaster}/graphql/`, {
          query: `
     query
     {
      promotionsRetrieve(id:${id})
      {
        name,description,id,active,photo,restaurants {
          name,description,id,photo
        }
      }
     }`,
        })
        .then(function (response) {
          state.promotionbyid = [];
          state.promotionbyid = response.data.data.promotionsRetrieve;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getAllMenu: function (state) {
      axios
        .post(`${urlmaster}/graphql/`, {
          query: `
     query
     {
      menuList
  {
    results
    {
      id,name,typeMenu,active,photo
          dish{
        id,name,price,description,active,photo
      }
    }
  }
     }`,
        })
        .then(function (response) {
          state.menulist = [];
          state.menulist = response.data.data.menuList.results;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getMenubyID: function (state, id) {
      axios
        .post(`${urlmaster}/graphql/`, {
          query: `
     query
     {
      menuRetrieve(id:${id})
      { id,name,typeMenu,
        dish{
          id,name,description,price,photo,order,active
        }
      }
     }`,
        })
        .then(function (response) {
          state.menubyid = [];
          state.menubyid = response.data.data.menuRetrieve;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getAllDish: function (state) {
      axios
        .post(`${urlmaster}/graphql/`, {
          query: `
     query
     {
     dishList{
       results{
         id,name,description,active,price,photo,delete,order
       }
     }
     }`,
        })
        .then(function (response) {
          state.dishlist = [];
          state.dishlist = response.data.data.dishList.results;
          for (var i = 0; i < state.dishlist.length; i++)
            state.dishlist[i].price = pricesyle(state.dishlist[i].price);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getAllSlot: function (state) {
      axios
        .post(`${urlmaster}/graphql/`, {
          query: `
     
     query
{
  slotsList {
    results{id,name,description,photo,active}
  }
}`,
        })
        .then(function (response) {
          state.slotlist = [];
          state.slotlist = response.data.data.slotsList.results;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getCasinobyID: function (state, id) {
      axios
        .post(`${urlmaster}/graphql/`, {
          query: `
      query
     {
      casinoall(id:${id})
      {
       id,name,contact,id,photo,segob,
            musicCalendar{
              description,eventName,musicalGenre,id,photo,date,hora,views
            },
                gamesLive
        {
          id, name, description, date, hora,photo
        },
        transmissions{
          id,name,description,date,hora,photo,views,order
        },
        restaurant
        {
          description,id,description,isOpen,isPrincipal,active,photo,name
        },
        slots
        {
          id,name,description,active,photo
        },
        buffets
        {
          id,name,breakfastPrice,lunchPrice,dinePrice,description,photo,date
        },
        levelpromotion
               {
         id,name,description,order,photo, active,
          promotions {
            id,name,description
          },
         raffles {
            id,name,description
         },
         rewards {
           id,name,description
         }
       },
        polls
        {
          id, name,description,active,
          cantAsk,
      cantTrue(idcasino:${id}),
      cantFalse(idcasino:${id}),
          questionnaire{
            id,name,cantTrue(idcasino:${id}),
            cantFalse(idcasino:${id}),cantResponse(idcasino:${id})
            
          }
        }
      }
     }`,
        })
        .then(function (response) {
          state.casinobyid = [];
          state.casinobyid = response.data.data.casinoall[0];
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getAllCasino: async function (state) {
      if (state.userdata[0].principal == true) {
        await axios
          .post(`${urlmaster}/graphql/`, {
            query: `
      query
     {
      casinoList{
       results{
         id,name,contact,phone,order,city{name},active,photo,shedule,lat,lng,segob,
       

       }
     }
     }`,
          })
          .then(function (response) {
            state.casinolist = [];
            state.casinolist = response.data.data.casinoList.results;
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        let id = state.userdata[0].id;

        axios
          .post(`${urlmaster}/graphql/`, {
            query: `
      query
      {
      userbyid(id:${id})
      {id, username,
        casino{  id,name,contact,phone,city{name},active,photo,shedule,lat,lng,segob,order
          
        }
      }
    }
      `,
          })
          .then(function (response) {
            state.casinolist = [];
            //state.restaurantlist = response.data.data.userbyid[0].casino;
            for (
              var i = 0;
              i < response.data.data.userbyid[0].casino.length;
              i++
            )
              state.casinolist.push(response.data.data.userbyid[0].casino[i]);
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    getAllFrecuency: function (state) {
      axios
        .post(`${urlmaster}/graphql/`, {
          query: `
     
     query
{
frecuencyall(id:0)
  {
    id,name,description,active
  }
}`,
        })
        .then(function (response) {
          state.frequencylist = [];
          state.frequencylist = response.data.data.frecuencyall;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getAllCity: function (state) {
      axios
        .post(`${urlmaster}/graphql/`, {
          query: `
     
     query
{
cityList{
  results{id,name,address,description,active}
}
}`,
        })
        .then(function (response) {
          state.citylist = [];
          state.citylist = response.data.data.cityList.results;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getAllRestaurant: async function (state) {
      if (state.userdata[0].principal == true) {
        await axios
          .post(`${urlmaster}/graphql/`, {
            query: `
     query
{
  restaurantbyid(id:0)
  {
     id,name,isOpen,phone,description,isPrincipal,photo,notif,casino{id,name,order},cantTableFree,totalTable,email,shedule,sheduleBegin,sheduleEnd,totalTable,
     menusof
     {
     id,active,name,order,photo,typeMenu  
     },
     buffets
     {
       id,name,breakfastPrice,lunchPrice,dinePrice,description,photo,date
     },
     menus{
      id,name,typeMenu,active,photo,order
    },
    reservations{
      id,client{id,name,number,movil},
      date,time,person,date,time,dateandtime,
      status
      {
        id,description,color
      },tstatus, tcolor, end, clientname, clientmovil, datetimeend
    }
  }
}
     `,
          })
          .then(function (response) {
            state.restaurantlist = [];
            state.restaurantlist = response.data.data.restaurantbyid;
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        let id = state.userdata[0].id;

        await axios
          .post(`${urlmaster}/graphql/`, {
            query: `
      query
      {
      userbyid(id:${id})
        {id, username,
          casino{ name,order,
            restaurant
            {
              id,name,isOpen,phone,description,isPrincipal,photo,casino{name},email,shedule,sheduleBegin,sheduleEnd,totalTable,
              menusof
              {
              id,active,name,order,photo,typeMenu  
              },
              menus
              {
              id,active,name,order,photo,typeMenu  
              },
              reservations{
                id,client{id,name,number,movil},
                date,time,person,date,time,dateandtime,
              
                status
                {
                  id,description,color
                },tstatus, tcolor, end, clientname, clientmovil, datetimeend
              },
              buffets
              {
                id,name,breakfastPrice,lunchPrice,dinePrice,description,photo,date
              }

            }
          }
        }
      }
      `,
          })
          .then(function (response) {
            state.restaurantlist = [];
            //state.restaurantlist = response.data.data.userbyid[0].casino;
            for (
              var i = 0;
              i < response.data.data.userbyid[0].casino.length;
              i++
            )
              for (
                var j = 0;
                j < response.data.data.userbyid[0].casino[i].restaurant.length;
                j++
              )
                state.restaurantlist.push(
                  response.data.data.userbyid[0].casino[i].restaurant[j]
                );
          })
          .catch(function (error) {
            console.log(error);
          });
      }
    },

    getVersionApp: async function (state) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: `query
      {
        versionApp{
          id
          version
          createdAt
          active
          urlVersion
          os
        }
      }
      `,
        })

        .then(function (response) {
          state.versionApp = null;

          state.versionApp = response.data.data.versionApp;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getImagesApp: async function (state) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: `query
        {
          imagesApp{
            id,
            restaurantImage,
            musicImage,
            slotsImage,
            gameImage,
   buffetImage,
   menuImage,
            casino{
              id,
              name,
            }
          }
        }`,
        })
        .then(function (response) {
          state.imageApp = null;

          state.imageApp = response.data.data.imagesApp.map((app) => {
            return [
              {
                imagen: app.restaurantImage,
                nombre: "Restaurante",
                field: "restaurant_image",
              },
              {
                imagen: app.musicImage,
                nombre: "Música en vivo",
                field: "music_image",
              },

              {
                imagen: app.slotsImage,
                nombre: "Slots",
                field: "slots_image",
              },

              {
                imagen: app.gameImage,
                nombre: "Juegos en vivo",
                field: "game_image",
              },

              {
                imagen: app.buffetImage,
                nombre: "Buffet",
                field: "buffet_image",
              },

              {
                imagen: app.menuImage,
                nombre: "Menu",
                field: "menu_image",
              },

              {
                casino: app.casino,
                app: app.id,
              },
            ];
          });
          console.log(state.imageApp);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  }, //Fin mutations*****************************************************************************************************************************************************
  actions: {
    async loadAllActiveReservation({ commit }, restaurantIds) {
      await commit("getAllActiveReservation", restaurantIds);
    },

    async loadVersion({ commit }) {
      await commit("getVersionApp");
    },

    UpdateVersion: async function ({ commit }, newVer) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation($id:Int,$version:String,$urlVersion:String,$active:Boolean,$os:String)
      {
        updateVersionapp(id:$id,version:$version,urlVersion:$urlVersion,active:$active,os:$os)
        {
          ver
          {
            id
            active
            version
            urlVersion
            createdAt
            os
          }
        }
      }
    `,
          variables: {
            id: newVer.id,
            version: newVer.version,
            urlVersion: newVer.urlVersion,
            active: newVer.active,
            os: newVer.os,
          },
        })
        .then(function (response) {
          console.log(response.data);

          commit("getVersionApp");
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    async loadImageApp({ commit }) {
      await commit("getImagesApp");
    },
    async login({ commit }, obj) {
      await commit("login", obj);
    },
    async LoadPolls({ commit }) {
      await commit("getPolls");
    },
    async LoadReservation({ commit }, id) {
      await commit("getReservation", id);
    },
    async LoadPromotionGeneral({ commit },id) {
      await commit("getPromotionGeneralList", id);
    },
    async LoadPromotionGeneralofCasino({ commit },id) {
      await commit("getPromotionGeneralofCasinoList", id);
    },
    async LoadAskofPoll({ commit }, id) {
      await commit("getAskofPoll", id);
    },
    async LoadDataUser({ commit }) {
      await commit("getDataUser");
    },
    LoadCasinoStadistic: async function ({ commit }) {
      await commit("getCasinoStadistic");
    },
    LoadConfig: async function ({ commit }) {
      await commit("getConfig");
    },
    LoadUserbyID: function ({ commit }, id) {
      commit("getUserbyId", id);
    },
    LoadCasinobyID: function ({ commit }, id) {
      commit("getCasinobyID", id);
    },
    LoadLevelbyCasino: async function ({ commit }, id) {
     await commit("getLevelsbyCasino", id);
         },
         LoadDownloadPromotionbyCasino: async function ({ commit }, id) {
          await commit("getDownloadPromotionbyCasino", id);
              },
              LoadPromotionExecutionbyPromotion: async function ({ commit }, id) {
                await commit("getPromotionExecutionbyPromotion", id);
                },
                LoadPromotionExecutionbyCasino: async function ({ commit }, id) {
                  await commit("getPromotionExecutionbyCasino", id);
                  }, 
    LoadRewardbyLevel: async function ({ commit }, id) {
      await commit("getRewardbyLevel", id);
      },
      LoadRafflebyLevel: async function ({ commit }, id) {
        await commit("getRafflebyLevel", id);
        },
    LoadRestaurantbyID: function ({ commit }, id) {
      commit("getRestaurantbyID", id);
    },
    LoadPromotionbyID: function ({ commit }, id) {
      commit("getPromotionbyID", id);
    },
    LoadPromotion: function ({ commit }) {
      commit("getAllPromotion");
    },
    LoadMenubyID: function ({ commit }, id) {
      commit("getMenubyID", id);
    },
    LoadUser: function ({ commit }) {
      commit("getAllUser");
    },
    LoadMenu: function ({ commit }) {
      commit("getAllMenu");
    },
    LoadDish: async function ({ commit }) {
      await commit("getAllDish");
    },
    LoadRestaurant: async function ({ commit }) {
      await commit("getAllRestaurant");
    },
    LoadSlot: function ({ commit }) {
      commit("getAllSlot");
    },
    LoadCasino: function ({ commit }) {
      commit("getAllCasino");
    },
    LoadCity: function ({ commit }) {
      commit("getAllCity");
    },
    LoadFrecuency: function ({ commit }) {
      commit("getAllFrecuency");
    },
    UpdatePhotoDownloadPromotion: async function ({ commit }, newpromotion) {
      var data = new FormData();
      data.append(
        "operations",
        `{"query":"mutation ($file: Upload,$id:Int) {\\n  updatedownloadpromotion(id:$id, photo: $file) {\\n   newDownloadPromotion {\\n      id\\n      photo\\n    }\\n  }\\n}","variables":{"id":"${newpromotion.id}","file":null},"operationName":null}`
      );
      data.append("map", '{"0":["variables.file"]}');
      data.append("0", newpromotion.photo);

      var config = {
        method: "post",
        url: `${urlmaster}/graphql/`,
        /*   headers: { 
          'Cookie': 'csrftoken=Y30rk7U1PcOnEUZxkREbn8AbUMCIdrWVlZO0HxWQcKXLm9jXBCF7oVGrEC2CkLqx', 
                },*/
        data: data,
      };

      await axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
        })
        .catch(function (error) {
          console.log(error);
        });

      commit("getDownloadPromotionbyCasino",newpromotion.casinoId);
    },
    UpdatePhotoPromotion: async function ({ commit }, newpromotion) {
      var data = new FormData();
      data.append(
        "operations",
        `{"query":"mutation ($file: Upload,$id:Int) {\\n  uploadphotopromotion(id:$id, photo: $file) {\\n    newPromotions {\\n      id\\n      photo\\n    }\\n  }\\n}","variables":{"id":"${newpromotion.id}","file":null},"operationName":null}`
      );
      data.append("map", '{"0":["variables.file"]}');
      data.append("0", newpromotion.photo);

      var config = {
        method: "post",
        url: `${urlmaster}/graphql/`,
        /*   headers: { 
          'Cookie': 'csrftoken=Y30rk7U1PcOnEUZxkREbn8AbUMCIdrWVlZO0HxWQcKXLm9jXBCF7oVGrEC2CkLqx', 
                },*/
        data: data,
      };

      await axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
        })
        .catch(function (error) {
          console.log(error);
        });

      commit("getAllPromotion");
    },


    AddPromotionPhotoGallery: async function ({ commit }, newpromotion) {
      var data = new FormData();
      data.append(
        "operations",
        `{"query":"mutation ($file: Upload,$id:Int) {\\n  addpromogeneralphoto(id:$id, photo: $file) {\\n    newPromotions {\\n      id\\n         }\\n  }\\n}","variables":{"id":"${newpromotion.id}","file":null},"operationName":null}`
      );
      data.append("map", '{"0":["variables.file"]}');
      data.append("0", newpromotion.photo);

      var config = {
        method: "post",
        url: `${urlmaster}/graphql/`,
        /*   headers: { 
          'Cookie': 'csrftoken=Y30rk7U1PcOnEUZxkREbn8AbUMCIdrWVlZO0HxWQcKXLm9jXBCF7oVGrEC2CkLqx', 
                },*/
        data: data,
      };

      await axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
        })
        .catch(function (error) {
          console.log(error);
        });

      commit("getPromotionGeneralofCasinoList",newpromotion.casinoId);
    },

    UpdatePhotoSlot: async function ({ commit }, newpromotion) {
      var data = new FormData();
      data.append(
        "operations",
        `{"query":"mutation ($file: Upload,$id:Int) {\\n  uploadphotoslot(id:$id, photo: $file) {\\n    newSlots {\\n      id\\n      photo\\n    }\\n  }\\n}","variables":{"id":"${newpromotion.id}","file":null},"operationName":null}`
      );
      data.append("map", '{"0":["variables.file"]}');
      data.append("0", newpromotion.photo);

      var config = {
        method: "post",
        url: `${urlmaster}/graphql/`,
        /*  headers: { 
          'Cookie': 'csrftoken=Y30rk7U1PcOnEUZxkREbn8AbUMCIdrWVlZO0HxWQcKXLm9jXBCF7oVGrEC2CkLqx', 
                },*/
        data: data,
      };

      await axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
        })
        .catch(function (error) {
          console.log(error);
        });

      commit("getAllSlot");
    },
    UpdatePhotoCasino: async function ({ commit }, newpromotion) {
      var data = new FormData();
      data.append(
        "operations",
        `{"query":"mutation ($file: Upload,$id:Int) {\\n  uploadphotocasino(id:$id, photo: $file) {\\n    newcasino {\\n      id\\n      photo\\n    }\\n  }\\n}","variables":{"id":"${newpromotion.id}","file":null},"operationName":null}`
      );
      data.append("map", '{"0":["variables.file"]}');
      data.append("0", newpromotion.photo);

      var config = {
        method: "post",
        url: `${urlmaster}/graphql/`,
        /* headers: { 
          'Cookie': 'csrftoken=Y30rk7U1PcOnEUZxkREbn8AbUMCIdrWVlZO0HxWQcKXLm9jXBCF7oVGrEC2CkLqx', 
                },*/
        data: data,
      };

      await axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
        })
        .catch(function (error) {
          console.log(error);
        });

      commit("getAllCasino");
    },
    UpdatePhotoMenuofResturant: async function ({ commit }, newpromotion) {
      var data = new FormData();
      data.append(
        "operations",
        `{"query":"mutation ($file: Upload,$id:Int) {\\n  uploadmenuofrestaurant(id:$id, photo: $file) {\\n    newMenu {\\n      id\\n      photo\\n    }\\n  }\\n}","variables":{"id":"${newpromotion.id}","file":null},"operationName":null}`
      );
      data.append("map", '{"0":["variables.file"]}');
      data.append("0", newpromotion.photo);

      var config = {
        method: "post",
        url: `${urlmaster}/graphql/`,
        /*    headers: { 
          'Cookie': 'csrftoken=Y30rk7U1PcOnEUZxkREbn8AbUMCIdrWVlZO0HxWQcKXLm9jXBCF7oVGrEC2CkLqx', 
                },*/
        data: data,
      };

      await axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
        })
        .catch(function (error) {
          console.log(error);
        });

      commit("getAllMenu");
    },
    UpdatePhotoMenu: async function ({ commit }, newpromotion) {
      var data = new FormData();
      data.append(
        "operations",
        `{"query":"mutation ($file: Upload,$id:Int) {\\n  uploadphotomenu(id:$id, photo: $file) {\\n    newMenu {\\n      id\\n      photo\\n    }\\n  }\\n}","variables":{"id":"${newpromotion.id}","file":null},"operationName":null}`
      );
      data.append("map", '{"0":["variables.file"]}');
      data.append("0", newpromotion.photo);

      var config = {
        method: "post",
        url: `${urlmaster}/graphql/`,
        /*    headers: { 
          'Cookie': 'csrftoken=Y30rk7U1PcOnEUZxkREbn8AbUMCIdrWVlZO0HxWQcKXLm9jXBCF7oVGrEC2CkLqx', 
                },*/
        data: data,
      };

      await axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
        })
        .catch(function (error) {
          console.log(error);
        });

      commit("getAllMenu");
    },
    UpdatePhotoDish: async function ({ commit }, newpromotion) {
      var data = new FormData();
      data.append(
        "operations",
        `{"query":"mutation ($file: Upload,$id:Int) {\\n  uploadphotodish(id:$id, photo: $file) {\\n    newDish {\\n      id\\n      photo\\n    }\\n  }\\n}","variables":{"id":"${newpromotion.id}","file":null},"operationName":null}`
      );
      data.append("map", '{"0":["variables.file"]}');
      data.append("0", newpromotion.photo);

      var config = {
        method: "post",
        url: `${urlmaster}/graphql/`,
        /*  headers: { 
          'Cookie': 'csrftoken=Y30rk7U1PcOnEUZxkREbn8AbUMCIdrWVlZO0HxWQcKXLm9jXBCF7oVGrEC2CkLqx', 
                },*/
        data: data,
      };

      await axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
        })
        .catch(function (error) {
          console.log(error);
        });

      commit("getAllDish");
    },


    UpdatePhotoBuffet: async function ({ commit }, newpromotion) {
      var data = new FormData();
      data.append(
        "operations",
        `{"query":"mutation ($file: Upload,$id:Int) {\\n  uploadphotobuffet(id:$id, photo: $file) {\\n    newrestaurant  }\\n}","variables":{"id":"${newpromotion.id}","file":null},"operationName":null}`
      );
      data.append("map", '{"0":["variables.file"]}');
      data.append("0", newpromotion.photo);

      var config = {
        method: "post",
        url: `${urlmaster}/graphql/`,
        data: data,
      };

      await axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
        })
        .catch(function (error) {
          console.log(error);
        });

      commit("getAllRestaurant");
    },

    UpdatePhotoRestaurant: async function ({ commit }, newpromotion) {
      var data = new FormData();
      data.append(
        "operations",
        `{"query":"mutation ($file: Upload,$id:Int) {\\n  uploadphotorestaurant(id:$id, photo: $file) {\\n    newRestaurant {\\n      name\\n      photo\\n    }\\n  }\\n}","variables":{"id":"${newpromotion.id}","file":null},"operationName":null}`
      );
      data.append("map", '{"0":["variables.file"]}');
      data.append("0", newpromotion.photo);

      var config = {
        method: "post",
        url: `${urlmaster}/graphql/`,
        data: data,
      };

      await axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
        })
        .catch(function (error) {
          console.log(error);
        });

      commit("getAllRestaurant");
    },

    UpdatePhotoMusicalCalendar: async function (
      { commit, state },
      newpromotion
    ) {
      var data = new FormData();
      data.append(
        "operations",
        `{"query":"mutation ($file: Upload,$id:Int) {\\n  uploadphotomusicalcalendar(id:$id, photo: $file, idcasino:${state.casinobyid.id}) {\\n    newMusicalCalendar {\\n            photo\\n    }\\n  }\\n}","variables":{"id":"${newpromotion.id}","file":null},"operationName":null}`
      );
      data.append("map", '{"0":["variables.file"]}');
      data.append("0", newpromotion.photo);

      var config = {
        method: "post",
        url: `${urlmaster}/graphql/`,
        data: data,
      };

      await axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
        })
        .catch(function (error) {
          console.log(error);
        });

      commit("getCasinobyID", state.casinobyid.id);
    },

    UpdatePhotoTransmissions: async function ({ commit, state }, newpromotion) {
      var data = new FormData();
      data.append(
        "operations",
        `{"query":"mutation ($file: Upload,$id:Int) {\\n  uploadphototransmissions(id:$id, photo: $file, idcasino:${state.casinobyid.id}) {\\n    newTransmission {\\n            photo\\n    }\\n  }\\n}","variables":{"id":"${newpromotion.id}","file":null},"operationName":null}`
      );
      data.append("map", '{"0":["variables.file"]}');
      data.append("0", newpromotion.photo);

      var config = {
        method: "post",
        url: `${urlmaster}/graphql/`,
        data: data,
      };

      await axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
        })
        .catch(function (error) {
          console.log(error);
        });

      commit("getCasinobyID", state.casinobyid.id);
    },

    UpdatePhotoGamesLive: async function ({ commit, state }, newpromotion) {
      var data = new FormData();
      data.append(
        "operations",
        `{"query":"mutation ($file: Upload,$id:Int) {\\n  uploadphotogameslive(id:$id, photo: $file, idcasino:${state.casinobyid.id}) {\\n    newGamesLive {\\n            photo\\n    }\\n  }\\n}","variables":{"id":"${newpromotion.id}","file":null},"operationName":null}`
      );
      data.append("map", '{"0":["variables.file"]}');
      data.append("0", newpromotion.photo);

      var config = {
        method: "post",
        url: `${urlmaster}/graphql/`,
        data: data,
      };

      await axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
        })
        .catch(function (error) {
          console.log(error);
        });

      commit("getCasinobyID", state.casinobyid.id);
    },

    UpdateImagesApp: async function ({ commit }, newImages) {
      const data = new FormData();
      data.append(
        "operations",
        `{"query": "mutation ($file: Upload, $field: String, $id: Int) {\\n  updateimageapp(id: $id, field: $field, image: $file) {\\n  updatedImagesApp {\\n  restaurantImage\\n  musicImage\\n slotsImage\\n  gameImage\\n}\\n }\\n}","variables": {"id": "${newImages.id}","file": null,"field": "${newImages.field}"},"operationName":null}`
      );
      data.append("map", '{"0":["variables.file"]}');
      data.append("0", newImages.image);
      const config = {
        method: "post",
        url: `${urlmaster}/graphql/`,
        data: data,
      };
      console.log(data);

      try {
        const response = await axios(config);
        console.log(JSON.stringify(response.data));
        commit("getImagesApp");
      } catch (error) {
        console.log(error);
      }
    },
    UpdatePhotoConfig: async function ({ commit }, newpromotion) {
      var data = new FormData();
      data.append(
        "operations",
        `{"query":"mutation ($file: Upload,$id:Int) {\\n  uploadconfig(id:$id, photo: $file) {\\n    result {\\n      name\\n      photo\\n    }\\n  }\\n}","variables":{"id":"${newpromotion.id}","file":null},"operationName":null}`
      );
      data.append("map", '{"0":["variables.file"]}');
      data.append("0", newpromotion.photo);

      var config = {
        method: "post",
        url: `${urlmaster}/graphql/`,
        /*  headers: { 
          'Cookie': 'csrftoken=Y30rk7U1PcOnEUZxkREbn8AbUMCIdrWVlZO0HxWQcKXLm9jXBCF7oVGrEC2CkLqx', 
                },*/
        data: data,
      };

      await axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
        })
        .catch(function (error) {
          console.log(error);
        });

      commit("getConfig");
    },

    UpdateConfig: async function ({ commit }, newcasino) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
        mutation($id:ID!,$name:String, $description:String)
        {
          updateConfig( newConfig:{id:$id,name:$name,description:$description})
          {
            ok
          }
          }
    `,
          variables: newcasino,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getConfig");
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    AddConfig: async function ({ commit }, newpromotion) {
      var data = new FormData();
      data.append(
        "operations",
        `{"query":"mutation ($file: Upload,$name:String,$description:String) {\\n  addconfig(name:$name, description:$description, photo: $file) {\\n    result {\\n      name\\n      photo\\n    }\\n  }\\n}","variables":{"name":"${newpromotion.name}","description":"${newpromotion.description}","file":null},"operationName":null}`
      );
      data.append("map", '{"0":["variables.file"]}');
      data.append("0", newpromotion.photo);

      var config = {
        method: "post",
        url: `${urlmaster}/graphql/`,
        /*   headers: { 
          'Cookie': 'csrftoken=Y30rk7U1PcOnEUZxkREbn8AbUMCIdrWVlZO0HxWQcKXLm9jXBCF7oVGrEC2CkLqx', 
                },*/
        data: data,
      };

      await axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
        })
        .catch(function (error) {
          console.log(error);
        });

      commit("getConfig");
    },
    UpdatePhotoRaffle: async function ({ commit }, newpromotion) {
      var data = new FormData();
      data.append(
        "operations",
        `{"query":"mutation ($file: Upload,$id:Int) {\\n  updaterafflephoto(id:$id, photo: $file) {\\n    newRaffle {\\n      id\\n      photo\\n    }\\n  }\\n}","variables":{"id":"${newpromotion.id}","file":null},"operationName":null}`
      );
      data.append("map", '{"0":["variables.file"]}');
      data.append("0", newpromotion.photo);

      var config = {
        method: "post",
        url: `${urlmaster}/graphql/`,
        /*   headers: { 
          'Cookie': 'csrftoken=Y30rk7U1PcOnEUZxkREbn8AbUMCIdrWVlZO0HxWQcKXLm9jXBCF7oVGrEC2CkLqx', 
                },*/
        data: data,
      };

      await axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
        })
        .catch(function (error) {
          console.log(error);
        });
        if (newpromotion.levelId !== undefined)
        commit("getRafflebyLevel",newpromotion.levelId);
    },
    UpdatePhotoReward: async function ({ commit }, newpromotion) {
      var data = new FormData();
      data.append(
        "operations",
        `{"query":"mutation ($file: Upload,$id:Int) {\\n  updaterewardphoto(id:$id, photo: $file) {\\n    newReward {\\n      id\\n      photo\\n    }\\n  }\\n}","variables":{"id":"${newpromotion.id}","file":null},"operationName":null}`
      );
      data.append("map", '{"0":["variables.file"]}');
      data.append("0", newpromotion.photo);

      var config = {
        method: "post",
        url: `${urlmaster}/graphql/`,
        /*   headers: { 
          'Cookie': 'csrftoken=Y30rk7U1PcOnEUZxkREbn8AbUMCIdrWVlZO0HxWQcKXLm9jXBCF7oVGrEC2CkLqx', 
                },*/
        data: data,
      };

      await axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
        })
        .catch(function (error) {
          console.log(error);
        });
if (newpromotion.levelId !== undefined)
        commit("getRewardbyLevel",newpromotion.levelId);
    },
    UpdatePhotoLevel: async function ({ commit }, newpromotion) {
      var data = new FormData();
      data.append(
        "operations",
        `{"query":"mutation ($file: Upload,$id:Int) {\\n  updatelevelphoto(id:$id, photo: $file) {\\n    newLevel {\\n      id\\n      photo\\n    }\\n  }\\n}","variables":{"id":"${newpromotion.id}","file":null},"operationName":null}`
      );
      data.append("map", '{"0":["variables.file"]}');
      data.append("0", newpromotion.photo);

      var config = {
        method: "post",
        url: `${urlmaster}/graphql/`,
        /*   headers: { 
          'Cookie': 'csrftoken=Y30rk7U1PcOnEUZxkREbn8AbUMCIdrWVlZO0HxWQcKXLm9jXBCF7oVGrEC2CkLqx', 
                },*/
        data: data,
      };

      await axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
        })
        .catch(function (error) {
          console.log(error);
        });
        if (newpromotion.casinoid !== undefined)
      commit("getLevelsbyCasino",newpromotion.casinoid);
    },
    ActivePromotionExecution: async function ({ commit }, newpromotion) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($id:Int)
      {
        activepromotion(id:$id)
        {
          newPromotionExecution{
            id,code
          }
        }
      }
  `,
          variables: newpromotion,
        })
        .then(function (response) {
          console.log(response.data);
                  if(newpromotion.casinoId === undefined)
            commit("getPromotionExecutionbyPromotion",newpromotion.promotionid);
        else
            commit("getPromotionExecutionbyCasino",newpromotion.casinoId);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    ChangeStateDownloadPromotion: async function ({ commit }, newpromotion) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($id:Int)
      {
        changestatedownloadpromotion(id:$id)
        {
          newDownloadPromotion{
            id,photo
          }
        }
      }
  `,
          variables: newpromotion,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getLevelsbyCasino",newpromotion.casinoid);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    ChangeStateLevel: async function ({ commit }, newpromotion) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($id:Int)
      {
        changestatelevel(id:$id)
        {
          newLevel{
            name,description
          }
        }
      }
  `,
          variables: newpromotion,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getLevelsbyCasino",newpromotion.casinoid);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    AddRaffle: async function ({ commit }, newpromotion) {
      var data = new FormData();
      data.append(
        "operations",
        `{"query":"mutation ($file: Upload,$name:String,$description:String) {\\n  addraffle(name:$name, description:$description,frequencyId:${newpromotion.frequencyId},levelId:${newpromotion.levelId} ,photo: $file) {\\n    newRaffle {\\n      name\\n         }\\n  }\\n}","variables":{"name":"${newpromotion.name}","description":"${newpromotion.description}","file":null},"operationName":null}`
      );
      data.append("map", '{"0":["variables.file"]}');
      data.append("0", newpromotion.photo);

      var config = {
        method: "post",
        url: `${urlmaster}/graphql/`,
             data: data,
      };

      await axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
        })
        .catch(function (error) {
          console.log(error);
        });

      commit("getRafflebyLevel",newpromotion.levelId);
    },
    UpdateRaflle: async function ({ commit }, newcasino) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation($id:Int,$name:String,$description:String,$frequencyId:Int,$levelId:Int)
      {
        updateraffle(id:$id,name:$name,description:$description,frequencyId:$frequencyId,levelId:$levelId)
        {
         newRaffle
     {
       id,name,description,order,active,photo,
       frequency{
         id,name,description
       },
       level
        {
          id,name,description
        }
     }
        }
        }
  `,
          variables: newcasino,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getRafflebyLevel",newcasino.frequencyId);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    ChangeStateRaffle: async function ({ commit }, newpromotion) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($id:Int)
      {
        changestateraffle(id:$id)
        {
          newRaffle{
            id,name,description,active
          }
        }
      }
  `,
          variables: newpromotion,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getRafflebyLevel",newpromotion.frequencyId);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    AddReward: async function ({ commit }, newpromotion) {
      var data = new FormData();
      data.append(
        "operations",
        `{"query":"mutation ($file: Upload,$name:String,$description:String) {\\n  addreward(name:$name, description:$description,frequencyId:${newpromotion.frequencyId},levelId:${newpromotion.levelId} ,photo: $file) {\\n    newReward {\\n      name\\n         }\\n  }\\n}","variables":{"name":"${newpromotion.name}","description":"${newpromotion.description}","file":null},"operationName":null}`
      );
      data.append("map", '{"0":["variables.file"]}');
      data.append("0", newpromotion.photo);

      var config = {
        method: "post",
        url: `${urlmaster}/graphql/`,
             data: data,
      };

      await axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
        })
        .catch(function (error) {
          console.log(error);
        });

      commit("getRewardbyLevel",newpromotion.levelId);
    },
    UpdateReward: async function ({ commit }, newcasino) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation($id:Int,$name:String,$description:String,$frequencyId:Int,$levelId:Int)
      {
        updatereward(id:$id,name:$name,description:$description,frequencyId:$frequencyId,levelId:$levelId)
        {
         newReward
     {
       id,name,description,order,active,photo,
       frequency{
         id,name,description
       },
       level
        {
          id,name,description
        }
     }
        }
        }
  `,
          variables: newcasino,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getRewardbyLevel",newcasino.frequencyId);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    ChangeStateReward: async function ({ commit }, newpromotion) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($id:Int)
      {
        changestatereward(id:$id)
        {
          newReward{
            id,name,description,active
          }
        }
      }
  `,
          variables: newpromotion,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getRewardbyLevel",newpromotion.frequencyId);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    AddDownloadPromotion: async function ({ commit }, newpromotion) {
      var data = new FormData();
      data.append(
        "operations",
        `{"query":"mutation ($file: Upload) {\\n  adddownloadpromotion(casinoId:${newpromotion.casinoid}, photo: $file) {\\n    newDownloadPromotion {\\n      id\\n         }\\n  }\\n}","variables":{"file":null},"operationName":null}`
      );
      data.append("map", '{"0":["variables.file"]}');
      data.append("0", newpromotion.photo);

      var config = {
        method: "post",
        url: `${urlmaster}/graphql/`,
             data: data,
      };

      await axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
        })
        .catch(function (error) {
          console.log(error);
        });

      commit("getDownloadPromotionbyCasino",newpromotion.casinoid);
    },
    AddLevel: async function ({ commit }, newpromotion) {
      var data = new FormData();
      data.append(
        "operations",
        `{"query":"mutation ($file: Upload,$name:String,$description:String) {\\n  addlevel(casinoid:${newpromotion.casinoid},name:$name, description:$description, photo: $file) {\\n    newLevel {\\n      name\\n         }\\n  }\\n}","variables":{"name":"${newpromotion.name}","description":"${newpromotion.description}","file":null},"operationName":null}`
      );
      data.append("map", '{"0":["variables.file"]}');
      data.append("0", newpromotion.photo);

      var config = {
        method: "post",
        url: `${urlmaster}/graphql/`,
             data: data,
      };

      await axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
        })
        .catch(function (error) {
          console.log(error);
        });

      commit("getLevelsbyCasino",newpromotion.casinoid);
    },

    UpdateLevel: async function ({ commit }, newcasino) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation($id:Int,$name:String,$description:String)
      {
        updatelevel(id:$id,name:$name,description:$description)
        {
         newLevel
    {
      id,name,description,photo
    }
        }
        }
  `,
          variables: newcasino,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getLevelsbyCasino",newcasino.casinoid);
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    AddPromotionGeneral: async function ({ commit }, newpromotion) {
      var data = new FormData();
      data.append(
        "operations",
        `{"query":"mutation ($file: Upload,$name:String,$description:String) {\\n  addpromotionprincipal(name:$name, description:$description, casinoId:${newpromotion.casinoId}, photo: $file) {\\n    newPromotions {\\n      name\\n         }\\n  }\\n}","variables":{"name":"${newpromotion.name}","description":"${newpromotion.description}","file":null},"operationName":null}`
      );
      data.append("map", '{"0":["variables.file"]}');
      data.append("0", newpromotion.photo);

      var config = {
        method: "post",
        url: `${urlmaster}/graphql/`,
             data: data,
      };

      await axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
        })
        .catch(function (error) {
          console.log(error);
        });

      commit("getPromotionGeneralofCasinoList",newpromotion.casinoId);
    },


    AddPromotion: async function ({ commit }, newpromotion) {
      var data = new FormData();
      data.append(
        "operations",
        `{"query":"mutation ($file: Upload,$name:String,$description:String) {\\n  addpromotion(name:$name, description:$description, photo: $file) {\\n    newPromotions {\\n      name\\n      photo\\n    }\\n  }\\n}","variables":{"name":"${newpromotion.name}","description":"${newpromotion.description}","file":null},"operationName":null}`
      );
      data.append("map", '{"0":["variables.file"]}');
      data.append("0", newpromotion.photo);

      var config = {
        method: "post",
        url: `${urlmaster}/graphql/`,
        /*   headers: { 
          'Cookie': 'csrftoken=Y30rk7U1PcOnEUZxkREbn8AbUMCIdrWVlZO0HxWQcKXLm9jXBCF7oVGrEC2CkLqx', 
                },*/
        data: data,
      };

      await axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
        })
        .catch(function (error) {
          console.log(error);
        });

      commit("getAllPromotion");
    },

    UpdateTranmissionOrder: async function ({ commit }, newcasino) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation($idtra:Int,$order:Int)
      {
        updatetransmissionsorde(idtra:$idtra,order:$order)
        {
          tranmission
          {
            id,name,order
          }
        }
        }
  `,
          variables: newcasino,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllCasino");
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    AddPollCasino: async function ({ commit }, newcasino) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation($idpoll:Int,$idcasino:Int)
      {
        addpollcasino(idcasino:$idcasino,idpoll:$idpoll)
        {
          poll
          {
            description,active,id
          }
        }
        }
  `,
          variables: newcasino,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllCasino");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    RemovePollCasino: async function ({ commit }, newcasino) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation($idpoll:Int,$idcasino:Int)
      {
        removepollcasino(idcasino:$idcasino,idpoll:$idpoll)
        {
          poll
          {
            description,active,id
          }
        }
        }
  `,
          variables: newcasino,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllCasino");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    NotificationbyEvent: async function ({ commit }, newcasino) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation($id:Int,$idcasino:Int,$type:Int,$message:String)
      {
      notificationbyevent(idcasino:$idcasino,eventid:$id,type:$type,message:$message)
        {
          newdevice
          
        }
        }
  `,
          variables: newcasino,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllCasino");
        })
        .catch(function (error) {
          console.log(error);
        });


        await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation($id:Int,$idcasino:Int,$type:Int,$message:String)
      {
      notificationbyeventios(idcasino:$idcasino,eventid:$id,type:$type,message:$message)
        {
          newdevice
          
        }
        }
  `,
          variables: newcasino,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllCasino");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    UpdateCasinoLocation: async function ({ commit }, newcasino) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($id:Int,$lat:String,$lng:String)
      {
        udpdatecasinolocation(id:$id,lat:$lat,lng:$lng)
        {
          newcasino{
            lat,lng,id
          }
        }
      }
  `,
          variables: newcasino,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllCasino");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    UpdatePromotionGeneral: async function ({ commit }, newpromotion) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($id:Int,$name:String,$description:String)
      {
        updatepromogeneral(id:$id,name:$name,description:$description)
         {
          newPromotions{
            name,description
          }
        }
      }
  `,
          variables: newpromotion,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getPromotionGeneralofCasinoList",newpromotion.casinoId);
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    UpdatePromotion: async function ({ commit }, newpromotion) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($id:Int,$name:String,$description:String)
      {
        updatepromotion(id:$id,name:$name,description:$description)
         {
          newPromotions{
            name,description
          }
        }
      }
  `,
          variables: newpromotion,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllPromotion");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    CreateReservation: async function ({ commit }, newreservation) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($idclient:Int,$idrestaurant:Int,$phone:String,$name:String,$date:Date,$time:Time,$cant:Int) {
        createreservation(idclient:$idclient,idrestaurant:$idrestaurant,name:$name,phone:$phone,date:$date,time:$time,cant:$cant)
        {
          newreservation
        {
          id,
          client{id,name,number},
          date,
          time
        }
        }
        
      }
  `,
          variables: newreservation,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getReservation", newreservation.idrestaurant);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    CancelReservation: async function ({ commit }, id) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation  {
        cancelreservation(id:${id})
        {
          result
        }
        
      }
  `,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getReservation", id);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    AddAdminCasino: async function ({ commit }, newrestaurant) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($idcasino:Int,$iduser:Int) {
        addadmincasino(idcasino: $idcasino, iduser: $iduser) {
          newcustomer 
          }
        
      }
  `,
          variables: newrestaurant,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getUserbyId", newrestaurant.iduser);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    RemoveAdminCasino: async function ({ commit }, newrestaurant) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($idcasino:Int,$iduser:Int) {
        removeadmincasino(idcasino: $idcasino, iduser: $iduser) {
          newcustomer 
          }
        
      }
  `,
          variables: newrestaurant,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getUserbyId", newrestaurant.iduser);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    AddRestaurantMenu: async function ({ commit }, newrestaurant) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($id:Int,$menu:String)
      {
        addrestaurantmenu(id:$id,menu:$menu)
        {
          newrestaurant
          {
           name
              
            
          }
        }
      }
  `,
          variables: newrestaurant,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getRestaurantbyID", newrestaurant.id);
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    RemoveRestaurantMenu: async function ({ commit }, newrestaurant) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($id:Int,$menu:String)
      {
        removerestaurantmenu(id:$id,menu:$menu)
        {
          newrestaurant
          {
           name
              
            
          }
        }
      }
  `,
          variables: newrestaurant,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getRestaurantbyID", newrestaurant.id);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    AddRestaurantPromotion: async function ({ commit }, newpromotion) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($idPromotion:Int,$nameRestaurant:String)
      {
        addrestaurantpromotion(idPromotion:$idPromotion,nameRestaurant:$nameRestaurant)
         {
          newPromotions{
            name,description
          }
        }
      }
  `,
          variables: newpromotion,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getPromotionbyID", newpromotion.idPromotion);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    RemoveRestaurantPromotion: async function ({ commit }, newpromotion) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($idPromotion:Int,$nameRestaurant:String)
      {
        removerestaurantpromotion(idPromotion:$idPromotion,nameRestaurant:$nameRestaurant)
         {
          newPromotions{
            name,description
          }
        }
      }
  `,
          variables: newpromotion,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getPromotionbyID", newpromotion.idPromotion);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    ChangeNotifPromotion: async function ({ commit }, newpromotion) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($id:Int)
      {
        changenotifpromotion(id:$id)
        {
          newPromotions{
            name,notif
          }
        }
      }
  `,
          variables: newpromotion,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllPromotion");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    ChangeNotifRestaurant: async function ({ commit }, newpromotion) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($id:Int)
      {
        changenotifrestaurant(id:$id)
        {
          newrestaurant{
            name,notif
          }
        }
      }
  `,
          variables: newpromotion,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllPromotion");
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    RemovePrincipalPhotoPromotionGeneral: async function ({ commit }, newpromotion) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: `
          mutation($idpromotion:Int,$idphoto:Int)
{
removepromogeneralphoto(idphoto:$idphoto,idpromotion:$idpromotion)
  {
    newPromotions
    {
      id,name, photo{id,photo,principal},
      gallery
      {
        id,photo,principal
      }
    }
  }
  
}
          `,
          variables: newpromotion,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getPromotionGeneralofCasinoList",newpromotion.casinoId);
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    SetPrincipalPhotoPromotionGeneral: async function ({ commit }, newpromotion) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: `
          mutation($idpromotion:Int,$idphoto:Int)
{
setpromogeneralphotopincipal(idphoto:$idphoto,idpromotion:$idpromotion)
  {
    newPromotions
    {
      id,name, photo{id,photo,principal},
      gallery
      {
        id,photo,principal
      }
    }
  }
  
}
          `,
          variables: newpromotion,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getPromotionGeneralofCasinoList",newpromotion.casinoId);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    ChangeStatePromotionGeneral: async function ({ commit }, newpromotion) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($id:Int)
      {
        changepromoprincipal(id:$id)
        {
          newPromotions{
            name,description
          }
        }
      }
  `,
          variables: newpromotion,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getPromotionGeneralofCasinoList",newpromotion.casinoId);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    ChangeStatePromotion: async function ({ commit }, newpromotion) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($id:Int)
      {
        changestatepromotion(id:$id)
        {
          newPromotions{
            name,description
          }
        }
      }
  `,
          variables: newpromotion,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllPromotion");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    AddDishMenu: async function ({ commit }, newmenu) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($idMenu:Int,$idDish:Int)
      {
        adddishinmenu(idMenu:$idMenu,idDish:$idDish)
         {
          newMenu{
            id,name,typeMenu,active
          }
        }
      }
  `,
          variables: newmenu,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getMenubyID", newmenu.idMenu);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    RemoveDishMenu: async function ({ commit }, newmenu) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($idMenu:Int,$idDish:Int)
      {
        removedishmenu(idMenu:$idMenu,idDish:$idDish)
         {
          newMenu{
            id,name,typeMenu,active
          }
        }
      }
  `,
          variables: newmenu,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getMenubyID", newmenu.idMenu);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    AddMenu: async function ({ commit }, newmenu) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($name:String,$typeMenu:String)
      {
        addmenu(name:$name,typeMenu:$typeMenu)
        {
          newMenu{
            id,name,typeMenu,active
          }
        }
      }
  `,
          variables: newmenu,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllMenu");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    UpdateMenuOrder: async function ({ commit }, newmenu) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($id:Int,$order:Int)
      {
        updatemenuorder(id:$id,order:$order)
        {
          newMenu{
            id,name,typeMenu,active,order
          }
        }
      }
  `,
          variables: newmenu,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllMenu");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    UpdateCasinoofOrder: async function ({ commit }, newmenu) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($id:Int,$order:Int)
      {
        updatecasinoorde(idcasino:$id,order:$order)
        {
          newcasino
    {
      id,name,order,active
    }
        }
      }
  `,
          variables: newmenu,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllCasino");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    UpdateMenofOrder: async function ({ commit }, newmenu) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($id:Int,$order:Int)
      {
        ordermenuofrestaurant(id:$id,order:$order)
        {
          newMenu{
            id,name,typeMenu,active,order
          }
        }
      }
  `,
          variables: newmenu,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllMenu");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    UpdateMenu: async function ({ commit }, newmenu) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($id:Int,$name:String,$typeMenu:String)
      {
        updatemenu(id:$id,name:$name,typeMenu:$typeMenu)
        {
          newMenu{
            id,name,typeMenu,active
          }
        }
      }
  `,
          variables: newmenu,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllMenu");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    ChangeStateMenu: async function ({ commit }, newmenu) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($id:Int)
      {
        changestatemenu(id:$id)
        {
          newMenu{
            id,name,typeMenu,active
          }
        }
      }
  `,
          variables: newmenu,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllMenu");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    AddDish: async function ({ commit }, newdish) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($name:String,$description:String,$price:Decimal)
      {
        adddish(name:$name,description:$description,price:$price)
      {
        newDish{
          active
        }
      
      
      }
      }
  `,
          variables: newdish,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllDish");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    UpdateDishOrder: async function ({ commit }, newdish) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($id:Int,$order:Int)
      {
        updatedishorder(id:$id,order:$order)
      {
        newDish{
          active
        }
      
      
      }
      }
  `,
          variables: newdish,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllDish");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    UpdateDish: async function ({ commit }, newdish) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($id:Int,$name:String,$description:String,$price:Decimal)
      {
        updatedish(id:$id,name:$name,description:$description,price:$price)
      {
        newDish{
          active
        }
      
      
      }
      }
  `,
          variables: newdish,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllDish");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    ChangeStateDish: async function ({ commit }, newdish) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($id:Int)
      {
        changestatedish(id:$id)
      {
        newDish{
          active
        }
      
      }
      }
  `,
          variables: newdish,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllDish");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    AddCasinoSlot: async function ({ commit }, newcasino) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($idcasino:Int,$name:String)
      {
        addcasinoslot(idcasino:$idcasino,name:$name)
        {
          newcasino
          {
            name
          }
        }
      }
  `,
          variables: newcasino,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getCasinobyID", newcasino.idcasino);
        })
        .catch(function (error) {
          console.log(error);
        });
    },


    RemovePromotionPrincipal: async function ({ commit }, newcasino) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($id:Int)
      {
       removepromotionpincipal(id:$id)
   {
    newPromotions
     }
      }
  `,
          variables: newcasino,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getPromotionGeneralofCasinoList", newcasino.casinoId);
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    RemoveCasinoSlot: async function ({ commit }, newcasino) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($idcasino:Int,$name:String)
      {
        removecasinoslot(idcasino:$idcasino,name:$name)
        {
          newcasino
          {
            name
          }
        }
      }
  `,
          variables: newcasino,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getCasinobyID", newcasino.idcasino);
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    AddCasinoGameLive: async function ({ commit }, newcasino) {
      var data = new FormData();
      data.append(
        "operations",
        `{"query":"mutation ($file: Upload,$idcasino:Int,$description:String,$name:String) {\\n  addcasinogamelive(idcasino:$idcasino,name:$name,description:$description, photo: $file) {\\n    newcasino {\\n      id\\n      photo\\n    }\\n  }\\n}","variables":{"idcasino":"${newcasino.idcasino}","name":"${newcasino.name}","description":"${newcasino.description}","file":null},"operationName":null}`
      );
      data.append("map", '{"0":["variables.file"]}');
      data.append("0", newcasino.photo);

      var config = {
        method: "post",
        url: `${urlmaster}/graphql/`,
        /*    headers: { 
          'Cookie': 'csrftoken=Y30rk7U1PcOnEUZxkREbn8AbUMCIdrWVlZO0HxWQcKXLm9jXBCF7oVGrEC2CkLqx', 
                },*/
        data: data,
      };

      await axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
          commit("getCasinobyID", newcasino.idcasino);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    AddCasinoBuffet: async function ({ commit }, newcasino) {
      var data = new FormData();
      data.append(
        "operations",
        `{"query":"mutation ($file: Upload,$idcasino:Int,$description:String,$name:String,$date:Date,$breakfast:String, $lunch:String,$dine:String) {\\n  addcasinobuffet(idcasino:$idcasino,name:$name,description:$description,date:$date,breakfast:$breakfast,lunch:$lunch,dine:$dine,photo:$file) {\\n    newcasino {\\n      id\\n      photo\\n    }\\n  }\\n}","variables":{"idcasino":"${newcasino.idcasino}","name":"${newcasino.name}","description":"${newcasino.description}","date":"${newcasino.date}","breakfast":"${newcasino.breakfastPrice}","lunch":"${newcasino.lunchPrice}","dine":"${newcasino.dinePrice}","file":null},"operationName":null}`
      );
      data.append("map", '{"0":["variables.file"]}');
      data.append("0", newcasino.photo);

      var config = {
        method: "post",
        url: `${urlmaster}/graphql/`,
        /*  headers: { 
          'Cookie': 'csrftoken=Y30rk7U1PcOnEUZxkREbn8AbUMCIdrWVlZO0HxWQcKXLm9jXBCF7oVGrEC2CkLqx', 
                },*/
        data: data,
      };

      await axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
          commit("getCasinobyID", newcasino.idcasino);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    AddRestaurantBuffet: async function ({ commit }, newcasino) {
      var data = new FormData();
      data.append(
        "operations",
        `{"query":"mutation ($file: Upload,$op:Int,$idrestaurant:Int,$description:String,$name:String,$date:Date,$breakfast:String, $lunch:String,$dine:String) {\\n  addrestaurantbuffet(idrestaurant:$idrestaurant,name:$name,description:$description,date:$date,breakfast:$breakfast,lunch:$lunch,dine:$dine,op:$op,photo:$file) {\\n    newrestaurant {\\n      id\\n      photo\\n    }\\n  }\\n}","variables":{"idrestaurant":"${newcasino.idrestaurant}","name":"${newcasino.name}","description":"${newcasino.description}","date":"${newcasino.date}","breakfast":"${newcasino.breakfastPrice}","lunch":"${newcasino.lunchPrice}","dine":"${newcasino.dinePrice}","op":"${newcasino.op}","file":null},"operationName":null}`
      );
      data.append("map", '{"0":["variables.file"]}');
      data.append("0", newcasino.photo);

      var config = {
        method: "post",
        url: `${urlmaster}/graphql/`,
        /*  headers: { 
          'Cookie': 'csrftoken=Y30rk7U1PcOnEUZxkREbn8AbUMCIdrWVlZO0HxWQcKXLm9jXBCF7oVGrEC2CkLqx', 
                },*/
        data: data,
      };

      await axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
          commit("getRestaurantbyID", newcasino.idrestaurant);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    AddCasinoTransmission: async function ({ commit }, newcasino) {
      var data = new FormData();
      data.append(
        "operations",
        `{"query":"mutation ($file: Upload,$idcasino:Int,$description:String,$name:String,$date:Date,$hora:Time,$op:Int) {\\n  addcasinotransmission(idcasino:$idcasino,name:$name,description:$description,date:$date,hora:$hora, op:$op,photo: $file) {\\n    newcasino {\\n      id\\n      photo\\n    }\\n  }\\n}","variables":{"idcasino":"${newcasino.idcasino}","name":"${newcasino.name}","description":"${newcasino.description}","date":"${newcasino.date}","hora":"${newcasino.hora}","op":"${newcasino.op}","file":null},"operationName":null}`
      );
      data.append("map", '{"0":["variables.file"]}');
      data.append("0", newcasino.photo);

      var config = {
        method: "post",
        url: `${urlmaster}/graphql/`,
        /*  headers: { 
          'Cookie': 'csrftoken=Y30rk7U1PcOnEUZxkREbn8AbUMCIdrWVlZO0HxWQcKXLm9jXBCF7oVGrEC2CkLqx', 
                },*/
        data: data,
      };

      await axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
          commit("getCasinobyID", newcasino.idcasino);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    AddCasinoMusicalCalendar: async function ({ commit }, newcasino) {
      var data = new FormData();
      data.append(
        "operations",
        `{"query":"mutation ($file: Upload,$idcasino:Int,$description:String,$eventName:String,$musicalGenre:String,$date:Date,$hora:String) {\\n  addcasinomusicalcalendar(idcasino:$idcasino,eventName:$eventName,musicalGenre:$musicalGenre,description:$description,date:$date,hora:$hora, photo: $file) {\\n    newcasino {\\n      id\\n      photo\\n    }\\n  }\\n}","variables":{"idcasino":"${newcasino.idcasino}","eventName":"${newcasino.eventName}","musicalGenre":"${newcasino.musicalGenre}","description":"${newcasino.description}","date":"${newcasino.date}","hora":"${newcasino.hora}","file":null},"operationName":null}`
      );
      data.append("map", '{"0":["variables.file"]}');
      data.append("0", newcasino.photo);

      var config = {
        method: "post",
        url: `${urlmaster}/graphql/`,
        /*  headers: { 
          'Cookie': 'csrftoken=Y30rk7U1PcOnEUZxkREbn8AbUMCIdrWVlZO0HxWQcKXLm9jXBCF7oVGrEC2CkLqx', 
                },*/
        data: data,
      };

      await axios(config)
        .then(function (response) {
          console.log(JSON.stringify(response.data));
          commit("getCasinobyID", newcasino.idcasino);
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    UpdateMusicalCalendar: async function ({ commit }, newcasino) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
        mutation($id:ID!,$eventName:String, $description:String,$date:CustomDate,$hora:String,$musicalGenre:String)
        {
          updateMusicCalendar( newMusicalcalendar:{id:$id,eventName:$eventName,description:$description,date:$date,hora:$hora,musicalGenre:$musicalGenre})
          {
            ok            
          }
        }
    `,
          variables: newcasino,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getCasinobyID", newcasino.idcasino);
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    UpdateGamesLive: async function ({ commit }, newcasino) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
        mutation($id:ID!,$name:String, $description:String)
        {
          updateGamesLive( newGameslive:{id:$id,name:$name,description:$description})
          {
            ok            
          }
        }
    `,
          variables: newcasino,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getCasinobyID", newcasino.idcasino);
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    UpdateTransmissions: async function ({ commit }, newcasino) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
        mutation($id:ID!,$name:String, $description:String,$date:CustomDate,$hora:CustomTime)
        {
          updateTransmissions( newTransmissions:{id:$id,name:$name,description:$description,date:$date,hora:$hora})
          {
            ok            
          }
        }
    `,
          variables: newcasino,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getCasinobyID", newcasino.idcasino);
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    RemoveCasinoGameLive: async function ({ commit }, newcasino) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($idcasino:Int,$idgame:Int)
      {
        removecasinogamelive(idcasino:$idcasino,idgame:$idgame)
          {
            newcasino{
              name,contact
            }
          }
      }
  `,
          variables: newcasino,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getCasinobyID", newcasino.idcasino);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    RemoveRestaurantBuffet: async function ({ commit }, newcasino) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($idrestaurant:Int,$idbuffet:Int)
      {
        removerestaurantbuffet(idrestaurant:$idrestaurant,idbuffet:$idbuffet)
          {
            newrestaurant{
              id
            }
          }
      }
  `,
          variables: newcasino,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getCasinobyID", newcasino.idcasino);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    RemoveCasinoBuffet: async function ({ commit }, newcasino) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($idcasino:Int,$idbuffet:Int)
      {
        removecasinobuffet(idcasino:$idcasino,idbuffet:$idbuffet)
          {
            newcasino{
              name,contact
            }
          }
      }
  `,
          variables: newcasino,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getCasinobyID", newcasino.idcasino);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    RemoveCasinoTransmission: async function ({ commit }, newcasino) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($idcasino:Int,$idmusical:Int)
      {
        removecasinotranmission(idcasino:$idcasino,idmusical:$idmusical)
          {
            newcasino{
              name,contact
            }
          }
      }
  `,
          variables: newcasino,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getCasinobyID", newcasino.idcasino);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    RemoveCasinoMusicalCalendar: async function ({ commit }, newcasino) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($idcasino:Int,$idmusical:Int)
      {
        removecasinomusicalcalendar(idcasino:$idcasino,idmusical:$idmusical)
          {
            newcasino{
              name,contact
            }
          }
      }
  `,
          variables: newcasino,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getCasinobyID", newcasino.idcasino);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    AddCasino: function ({ commit }, newcasino) {
      axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($name:String,$phone:String,$contact:String,$city:String,$shedule:String,$segob:String)
      {
      addcasino(name:$name,contact:$contact,phone:$phone,shedule:$shedule,city:$city,segob:$segob)
      {
         newcasino{id,name,contact,order,city{
            id,description
                 }
      }
      
      }
      }
  `,
          variables: newcasino,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllCasino");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    UpdateCasino: async function ({ commit }, newcasino) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($id:Int,$name:String,$phone:String,$contact:String,$city:String,$shedule:String,$segob:String)
      {
        updatecasino(id:$id,name:$name,contact:$contact,phone:$phone,shedule:$shedule,city:$city,segob:$segob)
        {
          newcasino{id,name,contact,order,city{
            id,description
          }}
        }
      }
  `,
          variables: newcasino,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllCasino");
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    ChangeStateCasino: async function ({ commit }, newcasino) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation
      {
      changestatecasino(id:${newcasino.id})
        {
          newcasino{id,name,contact,active,order,city{
            id,description
          }}
        }
      }
  `,
          variables: newcasino,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllCasino");
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    AddSlot: async function ({ commit }, newslot) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($name:String!,$description:String!)
      { 
       createSlots(newSlots:{name:$name,description:$description})
        {
          ok
        }
    }
  `,
          variables: newslot,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllSlot");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    UpdateSlot: async function ({ commit }, newslot) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($name:String!,$description:String!)
      { 
        updateSlots( newSlots:{id:${newslot.id},name:$name, description:$description})
        {
          ok
        }
    }
  `,
          variables: newslot,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllSlot");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    ChangeStatusSlot: async function ({ commit }, newslot) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation 
      { 
        updateSlots( newSlots:{id:${newslot.id},active:${newslot.active} })
        {
          ok
        }
    }
  `,
          variables: newslot,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllSlot");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    ChangeStatusDish: async function ({ commit }, newslot) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` mutation
{
  changestatedish(id:${newslot.id})
  {
    newDish
    {
      id,delete,active
    }
  }
}
    `,
          variables: newslot,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllDish");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    DeleteDish: async function ({ commit }, newslot) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` mutation
{
  deletedish(id:${newslot.id})
  {
    newDish
    {
      id,delete,active
    }
  }
}
    `,
          variables: newslot,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllDish");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    AddPollAsk: async function ({ commit }, newpoll) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($name:String!,$idpoll:Int!)
      { 
        addpollask(idpoll:$idpoll,name:$name)
        {
        newpoll
          {
            id,name,description
          }
        }
    }
  `,
          variables: newpoll,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getPolls");
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    ChangePollAsk: async function ({ commit }, newpoll) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($name:String!,$idask:Int!)
      { 
        changepollask(idask:$idask,name:$name)
        {
        newpoll
          {
            id,name,description
          }
        }
    }
  `,
          variables: newpoll,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getPolls");
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    RemovePollAsk: async function ({ commit }, newpoll) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($idask:Int)
      { 
        removepollask(idask:$idask)
        {
        newpoll
          {
            id,name,description
          }
        }
    }
  `,
          variables: newpoll,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getPolls");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    AddPoll: async function ({ commit }, newpoll) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($name:String!,$description:String!)
      { 
        addpoll(name:$name,description:$description)
        {
        newpoll
          {
            id,name,description
          }
        }
    }
  `,
          variables: newpoll,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getPolls");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    UpdatePoll: async function ({ commit }, newpoll) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($id:Int!,$name:String!,$description:String!)
      { 
        updatepoll(id:$id,name:$name,description:$description)
        {
        newpoll
          {
            id,name,description
          }
        }
    }
  `,
          variables: newpoll,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getPolls");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    ChangeStatePoll: async function ({ commit }, newpoll) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($id:Int!)
      { 
        changestatepoll(id:$id)
        {
        newpoll
          {
            id,name,description,active
          }
        }
    }
  `,
          variables: newpoll,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getPolls");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    AddFrecuency: async function ({ commit }, newfrecuency) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($name:String!,$description:String!)
      { 
     addfrecuency(name:$name, description:$description)
   {
     newFrequency {id,name,description,active}
   }
    }
  `,
          variables: newfrecuency,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllFrecuency");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    UpdateFrecuency: async function ({ commit }, newfrecuency) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($id:Int,$name:String!,$description:String!)
      { 
        updatefrecuency(id:$id,name:$name, description:$description)
        {
          newFrequency {id,name,description,active}
        }
    }
  `,
          variables: newfrecuency,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllFrecuency");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    ChangeStatusFrecuency: async function ({ commit }, newfrecuency) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation 
      { 
    changestatefrecuency(id:${newfrecuency.id})
   {
     newFrequency {id,name,description,active}
   }
    }
  `,
          variables: newfrecuency,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllFrecuency");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    AddCity: async function ({ commit }, newcity) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($name:String!,$description:String!)
      { 
        createCity( newCity:{name:$name, description:$description, address:"-",casino:1})
        {
          ok
        }
    }
  `,
          variables: newcity,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllCity");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    UpdateCity: async function ({ commit }, newcity) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($name:String!,$description:String!)
      { 
        updateCity( newCity:{id:${newcity.id},name:$name, description:$description, address:"-",casino:1})
        {
          ok
        }
    }
  `,
          variables: newcity,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllCity");
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    ChangeStatusCity: async function ({ commit }, newcity) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation 
      { 
        updateCity( newCity:{id:${newcity.id},active:${newcity.active}})
        {
          ok
        }
    }
  `,
          variables: newcity,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllCity");
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    ChangeStatusConfig: async function ({ commit }, newConfig) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation 
      { 
        updateConfig( newConfig:{id:${newConfig.id},active:${newConfig.active}})
        {
          ok
        }
    }
  `,
          variables: newConfig,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getConfig");
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    ChangeStatusVersion: async function ({ commit }, newVersion) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation 
      { 
        updateVersion( newVersionapp:{id:${newVersion.id},active:${newVersion.active}})
        {
          ok
        }
    }
  `,
          variables: newVersion,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getVersionApp");
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    AddRestaurant: async function ({ commit }, newrestaurant) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($name:String,$description:String,$phone:String,$casino:String,$total:Int,$email:String,$sheduleBegin:Time,$sheduleEnd:Time)
      { 
        addrestaurant(name:$name,description:$description,phone:$phone,casino:$casino,totalTable:$total,email:$email,sheduleBegin:$sheduleBegin,sheduleEnd:$sheduleEnd)
        {
          newrestaurant
          {
            active
          }
        }
    }
  `,
          variables: newrestaurant,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllRestaurant");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    UpdateRestaurant: async function ({ commit }, newrestaurant) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($id:Int,$name:String,$description:String,$phone:String,$casino:String,$total:Int,$email:String,$sheduleBegin:Time,$sheduleEnd:Time)
      { 
        updaterestaurant(id:$id,name:$name,description:$description,phone:$phone,casino:$casino,totalTable:$total,email:$email,sheduleBegin:$sheduleBegin,sheduleEnd:$sheduleEnd)
        {
          newrestaurant
          {
            active
          }
        }
    }
  `,
          variables: newrestaurant,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllRestaurant");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    ChangeRestauranOpenStatus: async function ({ commit }, newrestaurant) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation($id:Int)
      {
      changerestaurantatrib(id:$id,option:"open")
        {
          newrestaurant
          {
            isOpen,isPrincipal
          }
        }
      }
  `,
          variables: newrestaurant,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllRestaurant");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    ChangeRestauranPrincipalStatus: async function ({ commit }, newrestaurant) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation($id:Int)
      {
      changerestaurantatrib(id:$id,option:"principal")
        {
          newrestaurant
          {
            isOpen,isPrincipal
          }
        }
      }
  `,
          variables: newrestaurant,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllRestaurant");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    AddUser: async function ({ commit }, newuser) {
      //let namefunction = `createAccount`;
      //if (newuser.selectrole == 'Administrador') namefunction = `addAdmin`;

      await axios
        .post(`${urlmaster}/graphql/`, {
          query: `
          mutation ($username:String,$email:String,$firstname:String,$lastname:String,$password:String,$rol:String)
      {
        adduser(username:$username,email:$email,firstName:$firstname,lastName:$lastname,password:$password,rol:$rol)
        {
          newuser {id,username,firstName,lastName,email,isActive, rol }
        }
      }
  `,
          variables: newuser,
        })
        .then(function (response) {
          console.log(response.data);

          commit("getAllUser");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    UpdateUser: async function ({ commit }, updateuser) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: ` 
      mutation ($id:Int,$username:String,$email:String,$firstname:String,$lastname:String,$rol:String)
      {
        updateuser(id:$id,username:$username,email:$email,firstName:$firstname,lastName:$lastname,rol:$rol)
        {
          updateuser {id,username,firstName,lastName,email,isActive,rol }
        }
      } 
  `,
          variables: updateuser,
        })
        .then(function (response) {
          console.log(response.data);
          //console.log("El valor: "+response.data.data.addUser.updateuser.isActive);
          commit("getAllUser");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    ChangeStatusUser: async function ({ commit }, updateuser) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: `    mutation (,$isActive:Boolean)
      {
        updateAccount(newCustomuser:{id:${updateuser.id},isActive:$isActive})
        {
          ok
        }
      }  `,
          variables: updateuser,
        })
        .then(function (response) {
          console.log(response.data);
          //console.log("El valor: "+response.data.data.addUser.updateuser.isActive);
          commit("getAllUser");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    ChangePassword: async function ({ commit }, updateuser) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: `     mutation ($password:String)
      {
       changepassword(id:${updateuser.id},password:$password)
        {
          updateuser
          {
            id,username
          }
        }


      } `,
          variables: updateuser,
        })
        .then(function (response) {
          commit("getAllUser");
          console.log(response.data);
          //console.log("El valor: "+response.data.data.addUser.updateuser.isActive);
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    AddVersionApp: async function ({ commit }, newVersion) {
      await axios
        .post(`${urlmaster}/graphql/`, {
          query: `
          mutation($version:String,$urlVersion:String,$os:String){
            createVersionapp(version:$version,urlVersion:$urlVersion,os:$os){
              ver{
                id
                active
                version
                urlVersion
                createdAt
                os
              }
            }
          }
          `,
          variables: newVersion,
        })
        .then(function (response) {
          console.log(response.data.data);

          commit("getVersionApp");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  }, // Fin de Action************************************************************************** */
  getters: {
    GET_TOKEN(state) {
      return state.token;
    },

    GET_POOLBYCASINO(state) {
      return state.casinobyid.polls;
    },
    GET_POOL_ACTIVE(state) {
      return state.polllist.find((polllist) => polllist.active === true);
    },
    GET_MENUBYID_DISH_ACTIVE(state) {
      let add = [];
      for (let i = 0; i < state.menubyid.dish.length; i++)
        if (state.menubyid.dish[i].active === true)
          add.push(state.menubyid.dish[i]);

      return add;
    },
    GET_RESTAURANTBYID(state) {
      if (state.restaurantbyid.length > 0) return state.restaurantbyid[0];
      return undefined;
    },
    GET_DATARESTAURANT(state) {
      if (state.datarestaurant !== null) return state.datarestaurant;
      return undefined;
    },
    GET_RESERVATIONS(state) {
      let add = [];

      for (let i = 0; i < state.reservationlist.length; i++)
        add.push(state.reservationlist[i]);
      return add;
    },

    getVersionApp: (state) => state.versionApp,

    getImagesApp: (state) => state.imageApp,
  },
});
